import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  HostListener
} from '@angular/core';

import { DataService } from 'src/app/services/data.service';


import { AlertController, ModalController,LoadingController } from '@ionic/angular';

import { AttributesEditComponent } from '../attributes-edit/attributes-edit.component';
import { VariantsEditComponent } from '../variants-edit/variants-edit.component';
import { AttributesListOptionsComponent } from '../attributes-list-options/attributes-list-options.component';

@Component({
  selector: 'app-attributes-add',
  templateUrl: './attributes-add.component.html',
  styleUrls: ['./attributes-add.component.scss',],
})
export class AttributesAddComponent implements OnInit {
  @Input() product1;
  @Input() all_attributes;
  @Input() title:any;
  @Input() product_variants;
  @Input() attributes;
  view_more = false;
  store_attributes;
  store_price_base_attr;
  count = 1;
  @Input() is_attr = false;
  recursiveSearch__;
  possibilities:any = [];
  product;
  @Output() post_product = new EventEmitter();
  @ViewChild('customInput', { static: false }) customInput!: ElementRef;
  active = -1;
  show_ = false;

  constructor(public DBservice:DataService,public modalCtrl:ModalController,private alertCtrl: AlertController,private loadingCtrl:LoadingController) { }

  ngOnInit() {
    let value = JSON.stringify(this.product1);
    this.product = JSON.parse(value);

    // console.log(this.product);

    (this.product.product_attributes && this.product.product_attributes.length != 0) ? null : this.product.product_attributes = [];
  
    // console.log(this.all_attributes);
    this.store_attributes = this.all_attributes;
    (this.product.product_attributes && this.product.product_attributes.length != 0) ?  this.get_filtering() :  null;
    // console.log(this.product);
    this.get_filter_options();

    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');

  }


  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modalCtrl.dismiss();
  }


  get_filter_options(){
    if((this.product.attribute_options && this.product.attribute_options.length != 0) && (this.product.product_attributes && this.product.product_attributes.length != 0) ){
      this.product.product_attributes.map(res=>{
        let default_options:any = res.options; 
        res.options = [];

        let array_options = this.product.attribute_options.filter(r=> r.attribute == res.product_attribute);

        if(array_options.length != 0){
          // console.log(array_options);
          array_options.map(option=>{
            let datas = [{attribute_id :(option && option.name) ? (option.name + '\n') : '', 'option_value':option.option_value,'attribute':res.attribute,'price':0,'quantity':0}]
            res.options = [...res.options,...datas];

            if(res.all_options){
              res.all_options = res.options.length == res.all_options.length ? [] : res.all_options;
            }else{
              res.all_options = [];
            }
            
            if(this.product.variant_combination && this.product.variant_combination.length != 0){
               let check = this.product.variant_combination.find(variant=> { return variant.attribute_id && variant.attribute_id.includes(option.attribute_id)});
               if(check){
                res.is_active = true;
               }
            }

          })
        }
        else{
          res.options = default_options;
        }
      })
    }
  }

  show_more(index,item){
    this.active = index;
    this.show_= true;
    this.product.product_attributes.map((res,i)=>{
      i == index ? res.more_ = !res.more_ : res.more_ = false;

      if(i != index){
        res.more_ = false;
      }

    });
  }




  get_filtering(){

    // console.log(this.all_attributes);
    this.product.product_attributes.map((res,i)=>{
      res.more_ = res.more_ ? res.more_ : false;
      i == 0 ? res.more_ = true : ''
      res.is_active = res.is_active ? res.is_active : false;
      let d = this.all_attributes.find(data=> data.name == res.product_attribute)
     
      res.attribute = res.attribute ? res.attribute :  d.attribute_name;
      // res.attribute = d.name;
      res.options = res.options ? res.options : [];
      if(d){ 
        if(d.options && d.options.length != 0){
          
          if(res.options && res.options.length != 0){
            res.options.map(option_=>{

              let data_values = d.options.find(data=> option_.option_value == data.options) 
              if(data_values){
                d.options = d.options.filter(data=> data_values.options !== data.options);
                res.all_options = d.options;
                // console.log(d.options)
              }else{
                res.all_options = d.options;
              }
             
            })
          }else{
            res.all_options = d.options;
          }
          
        }else{
          res.all_options = d.options ? d.options : [];
        }

        this.all_attributes = this.all_attributes.filter(data=> data.name !== d.name);
        this.count == 1 ? localStorage['store'] = JSON.stringify(this.product) : null;
        this.count ++;
       } 
    })

    // console.log(this.all_attributes);
    // console.log(this.product.product_attributes);
   
  }


  get_dropdown(eve){
    // console.log(eve);
  }


  value_changed(event,item){
    event = (event.target && event.target.value) ? event.target.value : event;
    // console.log(item);
    // console.log(event);
    let option = item.all_options.find(r=> r.options == event)
    if(event != 'all'){
      // let datas = {'option_value' : event}
      // item.options.push(datas);
      let datas = [{attribute_id :(option && option.name) ? (option.name + '\n') : '', 'option_value':event,'attribute':item.attribute,'price':0,'quantity':0}]
      item.options = [...item.options,...datas];
      item.all_options = item.all_options.filter((item) => item.options !== event); 
      // this.get_filtering();
    }else{
      item.all_options.map((res,i)=>{
        // let datas = {'option_value' : res.options}
        // item.options.push(datas);
        // console.log(item.all_options.length,(i+1));
        let datas = [{attribute_id :(option && option.name) ? (option.name + '\n') : '','option_value':res.options,'attribute':item.attribute,'price':0,'quantity':0}]
        item.options = [...item.options,...datas];
        if(item.all_options.length == (i+1)) {
          this.all_attributes = this.store_attributes;
          this.get_filtering() 
        }

      })
    }
     
  }

  // add_option(data){
  //   if(data.option_values != '' && data.option_values != undefined){
  //     let datas = {'option_value' : data.option_values}

  //     // console.log(data);

  //     if((data.options && data.options.length != 0) || (data.all_options && data.all_options.length != 0)){
        
  //       // let d = data.options.find(res=> data.option_values.toUpperCase() == res.option_value.toUpperCase())
  //       // let d = data.all_options.find(res=> data.option_values.toUpperCase() == res.option_value.toUpperCase())
  //       let d = data.all_options.find(res=> data.option_values.toUpperCase() == res.options.toUpperCase())
  //       let a = data.options.find(res=> data.option_values.toUpperCase() == res.option_value.toUpperCase())
  //       // console.log(d)
  //       if(d || a){ 
  //         //  data.options = data.options.filter((item) => data.option_values !== d.option_values);    
  //          data.option_values = '';  
  //          data.alert = true;
  //          data.alert_msg = 'Already added in list';
  //          setTimeout(()=>{data.alert = false},1500);
  //        } else{
  //          data.options.push(datas);
  //          data.option_values = '';
  //          this.get_filtering();
  //        }

  //     }else{
  //       data.options = [];
  //       data.options.push(datas);
  //       // data.add_new = false;
  //       data.option_values = '';
  //       this.get_filtering();
  //     }
   
  //   }else{
  //     data.alert = true;
  //     data.alert_msg = 'Option is required';
  //     setTimeout(()=>{data.alert = false},1500);
  //   }   
  
  // }


  add_option(data){
    if(data.option_values != '' && data.option_values != undefined){
      let datas = {'option_value' : data.option_values}

      if((data.options && data.options.length != 0) || (data.all_options && data.all_options.length != 0)){
        
        let d = data.all_options.find(res=> data.option_values.toUpperCase() == res.options.toUpperCase())
        let a = data.options.find(res=> data.option_values.toUpperCase() == res.option_value.toUpperCase())

        if(d || a){ 
           data.option_values = '';  
           data.alert = true;
           data.alert_msg = 'Already added in list';
           setTimeout(()=>{data.alert = false},1500);
         } else{
           data.options.push(datas);
           data.option_values = '';
           this.get_filtering();
         }

      }else{
        data.options = [];
        data.options.push(datas);
        // data.add_new = false;
        data.option_values = '';
        this.get_filtering();
      }
   
    }else{
      data.alert = true;
      data.alert_msg = 'Option is required';
      setTimeout(()=>{data.alert = false},1500);
    }   
  
  }

  add_new_option(data:any){
    let datas = {
           "attribute":data.attribute, 
           "option_value":data.option_values, 
           "display_order": 0, 
           "attribute_id":data.product_attribute,
           "is_pre_selected":0,
           "parent":data.parent,
           "parentfield":"attribute_options",
           "parenttype": "Product",
           "doctype": "Product Attribute Option"
          }
    this.DBservice.add_update_variant_options(datas).subscribe(res=>{
      // console.log(res);
      // data.options.push(datas);
      // data.option_values = '';
      // this.get_filtering();
    })
  } 



  async delete__attr(index,data__){
    let alert = await this.alertCtrl.create({
      header: 'Delete',
      message: 'Do you really want to delete ?',
      buttons: [
        {
          text: 'No',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            data__.splice(index,1);
            this.all_attributes = this.store_attributes;
            this.get_filtering();
          }
        }
      ]
    })
    await alert.present();
   
  }

  edit__attr(){

  }

  remove(category,index){
    // console.log(category);
    if(category.options && category.options[index] && category.options[index].attribute_id){
      let remove_option = category.options[index].attribute_id.split('\n');

      // let data = { option_id : remove_option[0] };
      // let data = { "product": category.parent, "option_value": category.options[index].option_value, "attribute":category.product_attribute };

       // this.DBservice.remove_variant_options(data).subscribe(res=>{
       //   if(res && res.message && res.message.status == 'Success'){
          this.all_attributes = this.store_attributes;
          let data = this.all_attributes.find(res=> res.name == category.product_attribute);
          
          let find_value = data.options.find(res=> res.options.toUpperCase() == category.options[index].option_value.toUpperCase());
          if(!find_value){
            data.options.push({'options':category.options[index].option_value});
          }

          let attri_index = this.product.attribute_options.findIndex(r=> { return r.name == remove_option[0]})

          category.options.splice(index, 1);

          this.product.with_out_combo = this.product.product_attributes;

          if(attri_index > 0){
            this.product.attribute_options.splice(attri_index, 1);
            this.DBservice.update_product.next(this.product);
          }

          this.get_filtering();
         // }else{
         //  this.DBservice.alert('Something went wrong trg again later');
         // }
       // },error=>{ this.DBservice.alert('Something went wrong trg again later') })

    }else{
      this.all_attributes = this.store_attributes;
      let data = this.all_attributes.find(res=> res.name == category.product_attribute);
       
      let find_value = data.options.find(res=> res.options.toUpperCase() == category.options[index].option_value.toUpperCase());
        if(!find_value){
          data.options.push({'options':category.options[index].option_value});
        }

      category.options.splice(index, 1);
      this.get_filtering();
    }
  }


  async save_data(){

    let loader = await this.loadingCtrl.create({ message: 'Please Wait...'});
    await loader.present();

    let options:any=[];
    this.title == 'Add' ? this.product.attribute_options = []:''
    this.product.product_attributes.map(res=>{
      // console.log(res)
      res.control_type = res.control_type ? res.control_type :'Radio Button List';
      if(res.options && res.options.length > 0){
        res.options.map((op,i) => {
          op.attribute = res.product_attribute
          op.display_order = i
          options.push(op);
          this.title == 'Add' ? this.product.attribute_options.push(op) :'';
          // op.is_pre_selected = res.is_pre_selected
        })
      }
      res.attribute_option = res.options ? JSON.stringify(res.options) : [];
      // this.title == 'Add' ? this.product.attribute_options = res.options :'';
      // options.push(res.options)
      res.parent = this.product.name;
      res.parentfield = "product_attributes";
      res.parenttype ="Product";
      res.idx = this.product.idx;
      res.docstatus = this.product.docstatus;
      delete res.is_active;
      delete res.all_options;
      delete res.option_values;
      delete res.options;
    });

    if(this.title == 'Add'){

      this.get_filter_options();
      if(this.product.attribute_options && this.product.attribute_options.length > 0) 
        this.get_close(loader);
      else{
        loader.dismiss()
        this.modalCtrl.dismiss({'status':'success','item':this.product});
      }
      // let data={
      //   name:this.product.name,
      //   product_attributes:this.product.product_attributes
      // }
      // this.DBservice.insert_products(data).subscribe(res =>{
      //    if(res.message && res.message.status && res.message.status == "Success"){
      //     this.product = res.message.product;
  
      //     this.DBservice.get_product_details(this.product.name).subscribe(data => {
      //         this.product = data.message;
      //         this.get_filter_options();
      //         this.get_close(loader);
      //     },error=>{ loader.dismiss(),this.DBservice.alert('Something went wrong try again later') })
  
      //    }else if(res.message.status == 'failed'){
      //     loader.dismiss();
      //     if(res._server_messages){
      //       var d = JSON.parse(res._server_messages);
      //       var d1 = JSON.parse(d);
      //       this.DBservice.alert(d1.message);
      //     }else{
      //       this.DBservice.alert(res.message.status);
      //     }
      //  }
      // },error=>{ loader.dismiss(),this.DBservice.alert('Something went wrong try again later') })
    }else{
      let data={
        product:this.product.name,
        doctype:"Product",
        product_attributes:this.product.product_attributes,
        attribute_options:options
      }
      this.DBservice.update_products(data).subscribe(res =>{
         // let check:any = JSON.parse(res.message)
         // res.message = check
         if(res.message && res.message.name){
          res.message.name = res.message.product 
          let check_options = res.message.product_approval_item.find(obj => obj.field_name == 'attribute_options')
          if(check_options)
            res.message.attribute_options = check_options.new_value;
          let check_attribute = res.message.product_approval_item.find(obj => obj.field_name == 'product_attributes')
          if(check_attribute)
            res.message.product_attributes = check_attribute.new_value;
          console.log(res.message);
          this.product.attribute_options = res.message.attribute_options
          this.product.product_attributes = res.message.product_attributes
          this.get_filter_options();
          this.get_close(loader);
          // this.DBservice.get_product_details(this.product.name).subscribe(data => {
          //     this.product = data.message;
          //     this.get_filter_options();
          //     this.get_close(loader);
          // },error=>{ loader.dismiss(),this.DBservice.alert('Something went wrong try again later') })
  
         }else if(res.message.status == 'failed'){
          loader.dismiss();
          if(res._server_messages){
            var d = JSON.parse(res._server_messages);
            var d1 = JSON.parse(d);
            this.DBservice.alert(d1.message);
          }else{
            this.DBservice.alert(res.message.status);
          }
       }
      },error=>{ loader.dismiss(),this.DBservice.alert('Something went wrong try again later') })
    }
  
  
  }


  get_close(loader){
    this.store_price_base_attr = this.product.product_attributes;
    if(this.store_price_base_attr.length > 0 && this.store_price_base_attr.length == 1)
      this.recursiveSearch('','','','','','');
    if(this.store_price_base_attr.length > 0 && this.store_price_base_attr.length == 2)
      this.get_two_value();
    if(this.store_price_base_attr.length > 0 && this.store_price_base_attr.length == 3)
      this.get_value();

    this.product1 = this.product;
    loader.dismiss()
    this.modalCtrl.dismiss({'status':'success','item':this.product});

  }

  // save_data(){
  //   this.product.with_out_combo = this.product.product_attributes.filter(res=> { return !res.is_active });
  //   this.store_price_base_attr = this.product.product_attributes.filter(res=>{ return (res.is_active  && res.is_active == true) });
  //   if(this.store_price_base_attr.length > 0 && this.store_price_base_attr.length <= 2)
  //     this.recursiveSearch('','','','');
  //   if(this.store_price_base_attr.length > 0 && this.store_price_base_attr.length == 3)
  //     this.get_value();

  //   this.product1 = this.product;
  //   this.modalCtrl.dismiss({'status':'success','item':this.product});
  // }

  get_value(){
    var input1 = this.store_price_base_attr[0].options;
    var input2 = this.store_price_base_attr[1].options;
    var input3 = this.store_price_base_attr[2].options;
    var combination;
    var attribute_id;
    // Iterate through all combinations
    for (var i = 0; i < input1.length; i++) {
      for (var j = 0; j < input2.length; j++) {
        for (var k = 0; k < input3.length; k++) {
          combination = '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[0].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[0].options[i].option_value +'</span></div>'
          combination = combination + '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[1].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[1].options[j].option_value +'</span></div>'
          combination = combination + '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[2].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[2].options[k].option_value +'</span></div>'
          let attributes_com = input1[i].attribute_id + input2[j].attribute_id + input3[k].attribute_id
          let product_combination = [{attribute:this.store_price_base_attr[0].product_attribute,option:this.store_price_base_attr[0].options[i].option_value},{attribute:this.store_price_base_attr[1].product_attribute,option:this.store_price_base_attr[1].options[j].option_value},{attribute:this.store_price_base_attr[2].product_attribute,option:this.store_price_base_attr[2].options[k].option_value}]
          let data = [{attribute_id:attributes_com,'attribute_html':combination,'varient_json': '','weight':0,'stock':this.product.stock,'is_pre_selected':0,'detail_thumbnail':'','sku':'','price':this.product.price,'image_list':[],"product_combination":product_combination}]
          this.possibilities = [...this.possibilities,...data]
        }
      }
    }
    this.product.variant_combination = this.possibilities 
  }

  get_two_value(){
    var input1 = this.store_price_base_attr[0].options;
    var input2 = this.store_price_base_attr[1].options;
    var combination;
    var attribute_id;
    // Iterate through all combinations
    for (var i = 0; i < input1.length; i++) {
      for (var j = 0; j < input2.length; j++) {
          combination = '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[0].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[0].options[i].option_value +'</span></div>'
          combination = combination + '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[1].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[1].options[j].option_value +'</span></div>'
          let attributes_com = input1[i].attribute_id + input2[j].attribute_id 
          let product_combination = [{attribute:this.store_price_base_attr[0].product_attribute,option:this.store_price_base_attr[0].options[i].option_value},{attribute:this.store_price_base_attr[1].product_attribute,option:this.store_price_base_attr[1].options[j].option_value}]
          let data = [{attribute_id:attributes_com,'attribute_html':combination,'varient_json': '','weight':0,'stock':this.product.stock,'is_pre_selected':0,'detail_thumbnail':'','sku':'','price':this.product.price,'image_list':[],"product_combination":product_combination}]
          this.possibilities = [...this.possibilities,...data]
      }
    }
    this.product.variant_combination = this.possibilities 
  }

  recursiveSearch(text, depth,html_value,attribute_id,attr,attr_option){
    text = text || "";
    html_value = html_value || "";
    attribute_id = attribute_id || "";
    depth = depth || 0;
    attr = attr || "";
    attr_option = attr_option || "";
    if(this.store_price_base_attr.length > 0){
    for (var i = 0; i < this.store_price_base_attr[depth].options.length; i++ ){
      if (depth + 1 < this.store_price_base_attr.length){
        let d= '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].options[i].option_value +'</span></div>'
        html_value = html_value  + '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].options[i].option_value +'</span></div>'
        attribute_id = this.store_price_base_attr[depth].options[i].attribute_id
        attr = attr + this.store_price_base_attr[depth].product_attribute
        attr_option = attr_option + this.store_price_base_attr[depth].product_attribute
        // console.log(attr)
        // console.log(attr_option)
        this.recursiveSearch( text + ((text=="") ? "" : " ") + this.store_price_base_attr[depth].options[i].option_value , depth +1, d,attribute_id,attr,attr_option);
       }else{
        let html_json = html_value + '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].options[i].option_value +'</span></div>'
        let attributes_com = attribute_id + this.store_price_base_attr[depth].options[i].attribute_id
        // console.log(attr)
        // console.log(attr_option)
        let attribute_json:any = [];
        attribute_json.push({ option :this.store_price_base_attr[depth].options[i].option_value,attribute:this.store_price_base_attr[depth].product_attribute})
        // console.log(attribute_json)
        // let html_json = html_value + '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].options[i].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].options[i].option_value +'</span></div>'
        // console.log(this.store_price_base_attr[depth].options[i]);
        // html_value = html_value + '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].options[i].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].options[i].option_value +'</span></div>'
        // html_value = html_value + '<div class=\"btn btn-default btn-xs btn-link-to-form\" style=\"border: 1px solid #d1d8dd;margin: 2px;min-width: 50px;text-align: left;\"><p style=\"text-align: left;margin: 0px;font-size: 11px;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].options[i].attribute +'</p> <span style=\"font-weight: 700;white-space: initial;word-wrap: break-word;\">'+ this.store_price_base_attr[depth].options[i].option_value +'</span></div>'
        let data = [{attribute_id:attributes_com,'attribute_html':html_json,'varient_json': text +' '+ this.store_price_base_attr[depth].options[i].option_value,'weight':0,'stock':this.product.stock,'is_pre_selected':0,'detail_thumbnail':'','sku':'','price':this.product.price,'image_list':[],"product_combination":attribute_json}]
        this.possibilities = [...this.possibilities,...data]
      }
     // }
    }
   }
   this.product.variant_combination = this.possibilities;
 }
  
  add_new_attr(new_attr){
    let datas = {'product_attribute' : new_attr.name};
    this.product.product_attributes.push(datas);
    this.all_attributes = this.store_attributes;
    let index = this.product.product_attributes.length - 1
    this.show_more(index,this.product.product_attributes[index]);
    this.is_attr = false;
    this.get_filtering();
    this.DBservice.update_product.next(this.product);
    this.modalCtrl.dismiss({'status':'success','item':this.product});
  }

  
  async add_attribute(){
    const modal = await this.modalCtrl.create({
      component : AttributesAddComponent,
      cssClass : 'report-popup',
      componentProps : {
        product1:this.product,
        is_attr: true,
        all_attributes:this.all_attributes,
      }
    })

    await modal.present();
    await modal.onWillDismiss().then(res =>{
      if(res.data && res.data.status == 'success'){
        this.product = res.data.item
      }
    })
  }  

  focusof() {
    this.customInput?.nativeElement?.focus();
  }

  
  async open_variants_pop_up(select_item,obj) {
   // console.log(select_item)
    const modal = await this.modalCtrl.create({   
      component: AttributesListOptionsComponent,
      cssClass: 'options-pop-up',
      componentProps:{
        product_values:select_item
      },
      // enterAnimation: this.enterAnimation ,
      // leaveAnimation: this.leaveAnimation,
     })
     await modal.present();

     const { data } = await modal.onWillDismiss();
      if (data && data.status && data.status == 'success') {
        // console.log(data);
        let list = data.data.filter(r=>{return r['isActive'] == true})
        // obj.all_options = data.data.filter(r=>{return (r['isActive'] == undefined || r['isActive'] == false) })

       if(list.length != 0){
        list.map(option=>{
          option.isActive ? delete option.isActive : null;
          option.name ? delete option.name : null;
          // let datas = [{attribute_id :(option && option.name) ? (option.name + '\n') : '', 'option_value':option.options,'attribute':obj.attribute,'price':0,'quantity':0}]
          // obj.options = [...obj.options,...datas];
           
          this.value_changed(option.options,obj);
         })
       }

      //  this.get_filtering();
      //  this.all_attributes = this.store_attributes;
      //  console.log(this.all_attributes);
       // console.log(this.product.product_attributes);
       
      }
  } 

  // ion-model slide left transaction
  // enterAnimation = (baseEl: HTMLElement) => { 
  //   var root:any = baseEl.shadowRoot;
  //   const backdropAnimation = this.animationCtrl
  //     .create()
  //     .addElement(root.querySelector('ion-backdrop')!)
  //     .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

  //   const wrapperAnimation = this.animationCtrl
  //     .create()
  //     .addElement(root.querySelector('.modal-wrapper')!)
  //     .keyframes([
  //       this.db.ismobile ? { offset: 0, opacity: '0.09', transform: 'translateY(100%)' } : { offset: 0, opacity: '0.09', transform: 'translateX(100%)' },
  //       this.db.ismobile ? { offset: 1, opacity: '1', transform: 'translateY(0)' } : { offset: 1, opacity: '1', transform: 'translateX(0)' },
  //     ]);
  //   return this.animationCtrl
  //     .create()
  //     .addElement(baseEl)
  //     .easing('ease-out')
  //     .duration(500)
  //     .addAnimation([backdropAnimation, wrapperAnimation]);
  // };

  // leaveAnimation = (baseEl: HTMLElement) => {
  //   return this.enterAnimation(baseEl).direction('reverse');
  // };
}


